import classNames from 'classnames';
import { useState } from 'react';
import { forwardRef } from 'react';
import { useDebounceCallback, useEventListener } from 'usehooks-ts';

import useScrollDirection from '@/utils/hooks/useScrollDirection';

const ScrollGradient = forwardRef<HTMLDivElement, { notSticky?: boolean }>(({ notSticky }, ref) => {
  const [displayGradient, setDisplayGradient] = useState(false);
  const scrollDirection = useScrollDirection();

  const debouncedHandleScroll = useDebounceCallback((event: Event) => {
    if (ref && 'current' in ref && ref.current) {
      const scrollY = window.scrollY;
      const gradientStandardTop = ref.current.offsetTop;

      setDisplayGradient(scrollY > gradientStandardTop);
    }
  }, 100);

  useEventListener('scroll', debouncedHandleScroll);

  return (
    displayGradient && (
      <div
        className={classNames('scroll_gradient', {
          sticky: !notSticky && scrollDirection === 'up',
        })}
      ></div>
    )
  );
});

ScrollGradient.displayName = 'ScrollGradient';

export default ScrollGradient;
